import { PATHS } from "@/lib/router";
import { CompanySetupPage } from "./pages";

export const companyRoutes = [
  {
    path: PATHS.COMPANY_SETUP,
    element: <CompanySetupPage />,
  },
];
